import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppMaterialModule } from 'app/app-material.module';
import { OperatorDashboardDatePickerComponent } from 'app/components/operator/dashboard/operator-dashboard-date-picker.component';

@NgModule({
	declarations: [OperatorDashboardDatePickerComponent],
	imports: [
		CommonModule,
		FormsModule,
		OverlayModule,
		AppMaterialModule
	],
	exports: [OperatorDashboardDatePickerComponent]
})
export class OperatorDatePickerModule { }
